import HttpServer from '../httpServer';
import { useStore } from 'vuex';
export default {
  getBatchList(params) {
    return HttpServer.get(`/prod-api/recruitment/applicant/selectActivity`, params);
  },
  getJobList(params) {
    return HttpServer.get(`/prod-api/recruitment/applicant/findActivityById`, params, {
      showLoading: true,
    });
  },
  // 投递
  deliverResume(params) {
    return HttpServer.post(`/prod-api/recruitment/applicant/addApplication`, params);
  },
  resendResume(params) {
    return HttpServer.post(`/prod-api/recruitment/applicant/resendApplication`, params);
  },
  deletedeliver(basicId) {
    return HttpServer.post(`/prod-api/recruitment/applicant/deleteApplication/${basicId}`);
  },
  getMyDeliver(basicId) {
    return HttpServer.get(`/prod-api/recruitment/applicant/findApplication/${basicId}`, null, {
      notShowMessage: true,
    });
  },
  //   简历相关
  getResume(params) {
    return HttpServer.get(`/prod-api/recruitment/applicant/selectResume`, params);
  },
  // 更新基础信息
  addResumeBasic(params) {
    return HttpServer.post(`/prod-api/recruitment/applicant/addResumeBasic`, params);
  },
  updateResumeBasic(params) {
    return HttpServer.post(`/prod-api/recruitment/applicant/updateResumeBasic`, params);
  },
  // 更新家庭信息
  addResumeHome(params) {
    return HttpServer.post(`/prod-api/recruitment/applicant/addResumeHome`, params);
  },
  updateResumeHome(params) {
    return HttpServer.post(`/prod-api/recruitment/applicant/updateResumeHome`, params);
  },
  deleteResumeHome(id) {
    return HttpServer.post(`/prod-api/recruitment/applicant/deleteResumeHome/${id}`);
  },
  // 更新教育经历
  addResumeEducation(params) {
    return HttpServer.post(`/prod-api/recruitment/applicant/addResumeEducational`, params);
  },
  updateResumeEducation(params) {
    return HttpServer.post(`/prod-api/recruitment/applicant/updateResumeEducational`, params);
  },
  deleteResumeEducation(id) {
    return HttpServer.post(`/prod-api/recruitment/applicant/deleteResumeEducational/${id}`);
  },
  // 更新工作经历
  addResumeWork(params) {
    return HttpServer.post(`/prod-api/recruitment/applicant/addResumeRecord`, params);
  },
  updateResumeWork(params) {
    return HttpServer.post(`/prod-api/recruitment/applicant/updateResumeRecord`, params);
  },
  deleteResumeWork(id) {
    return HttpServer.post(`/prod-api/recruitment/applicant/deleteResumeRecord/${id}`);
  },
  // 更新业务获奖
  addResumeAward(params) {
    return HttpServer.post(`/prod-api/recruitment/applicant/addResumeAward`, params);
  },
  updateResumeAward(params) {
    return HttpServer.post(`/prod-api/recruitment/applicant/updateResumeAward`, params);
  },
  deleteResumeAward(id) {
    return HttpServer.post(`/prod-api/recruitment/applicant/deleteResumeAward/${id}`);
  },
  // 更新业务获奖
  addResumeAchievement(params) {
    return HttpServer.post(`/prod-api/recruitment/applicant/addResumeAchievement`, params);
  },
  updateResumeAchievement(params) {
    return HttpServer.post(`/prod-api/recruitment/applicant/updateResumeAchievement`, params);
  },
  deleteResumeAchievement(id) {
    return HttpServer.post(`/prod-api/recruitment/applicant/deleteResumeAchievement/${id}`);
  },
  // 更新奖惩
  addResumeDesert(params) {
    return HttpServer.post(`/prod-api/recruitment/applicant/addResumeDesert`, params);
  },
  updateResumeDesert(params) {
    return HttpServer.post(`/prod-api/recruitment/applicant/updateResumeDesert`, params);
  },
  deleteResumeDesert(id) {
    return HttpServer.post(`/prod-api/recruitment/applicant/deleteResumeDesert/${id}`);
  },
  // 更新论文论著
  addResumePublication(params) {
    return HttpServer.post(`/prod-api/recruitment/applicant/addResumePublication`, params);
  },
  updateResumePublication(params) {
    return HttpServer.post(`/prod-api/recruitment/applicant/updateResumePublication`, params);
  },
  deleteResumePublication(id) {
    return HttpServer.post(`/prod-api/recruitment/applicant/deleteResumePublication/${id}`);
  },
  // 更新个人荣誉及奖励
  addResumeHonor(params) {
    return HttpServer.post(`/prod-api/recruitment/applicant/addResumeHonor`, params);
  },
  updateResumeHonor(params) {
    return HttpServer.post(`/prod-api/recruitment/applicant/updateResumeHonor`, params);
  },
  deleteResumeHonor(id) {
    return HttpServer.post(`/prod-api/recruitment/applicant/deleteResumeHonor/${id}`);
  },
  // 更新其他情况|简历附件
  updateResumeSelective(params) {
    return HttpServer.post(`/prod-api/recruitment/applicant/updateResumeBasicSelective`, params);
  },
  //查看准考证
  findMyAdmission(params) {
    return HttpServer.get(`/prod-api/recruitment/applicant/findMyAdmission/${params.basicId}`, null, {
      notShowMessage: true,
    });
  },
  // 下载准考证（只记录下载状态，不传文档流）
  downLoadAdmission(params) {
    return HttpServer.get(`/prod-api/recruitment/applicant/loadAdmission/${params.basicId}`, null, {
      notShowMessage: true,
    });
  },
  //  查询招聘进度
  getRecruitProgress(params) {
    return HttpServer.get(`/prod-api/recruitment/applicant/viewProgress?activityId=${params.activityId}&basicId=${params.basicId}`);
  },
  // 修改笔试|面试|录用确认状态
  updateConfirmStatus(params) {
    return HttpServer.post(`/prod-api/recruitment/applicant/updateConfirmStatus`, params);
  },
  // 查看成绩
  findWrittenExamScore(params) {
    return HttpServer.get(`/prod-api/recruitment/applicant/findWrittenExamScore?activityId=${params.activityId}&basicId=${params.basicId}`);
  },
  //   配置
  async getConf(params) {
    const store = useStore();
    if (!store.state.dicOptions.areaVos.length) {
      const res = await HttpServer.get(`/prod-api/recruitment/applicant/findConfList`, params);
      store.commit('SET_DICOPTIONS', res);
    }
    return store.state.dicOptions;
  },
};
